<template>
  <transition name="slide">
    <div
      class="slidein"
      v-if="drawer"
      style="width:100% !important; height: fit-content !important; margin-top: 90%; border-radius: 20px 20px 0 0;
      background: white; box-shadow: 0px 4px 20px rgba(114, 114, 114, 0.1);"
    >
      <div style="align-items: center;width:100%;height:auto;" >
        <v-row>
          <v-col cols="12" style="font-size: 16px;">
            <ol>
              <li>คุ้มครองรายเดี่ยว คนละ 35 บาท (รวมอากร)</li>
              <li>
                โดยทาง Joy Ride รวบรวมรายชื่อตามข้อมูลที่ขอในแบบฟอร์ม Excel
                (ซึ่งจะจัดส่งให้อีกครั้งหลังท่านยืนยันข้อเสนอ) ส่งกลับ TQM และ
                DHP ก่อนวันเริ่มคุ้มครอง (วันเดินทาง) ขั้นต่ำล่วงหน้า 1-2 วัน
                เพื่อแจ้งความประสงค์เอาประกัน
              </li>
              <li>กรมธรรม์ไม่มีการยกเลิก หากได้แจ้งรายชื่อเอาประกันแล้ว</li>
              <li>กรมธรรม์จะออกเป็น certificate ส่งให้ทาง Joy Ride</li>
              <li>
                คุ้มครองรายกลุ่ม ขั้นต่ำ ฉบับละ 3,500 บาท สำหรับจำนวน 100
                /เที่ยว/คน/ฉบับ/ปี (รวมอากร) และทำสลักหลังเพิ่ม ผู้เอาประกัน
                ตามที่มีการใช้บริการโดยทาง Joy Ride ชำระค่าเบี้ยประกันภัยก่อน
                3,500 บาท เพื่อสำรองไว้ก่อน 100 คน และทางประกันภัยออกกรมธรรม์ให้
                และทาง Joy Ride รวบรวมรายชื่อตามข้อมูลที่ขอในแบบฟอร์ม Excel
                (ซึ่งจะจัดส่งให้อีกครั้งหลังท่านยืนยันข้อเสนอ) ส่งกลับ TQM และ
                DHP เป็นรายเดือน Adjust ไปเรื่อยๆ จนครบ 100 คน หากเกิน 100 คน
                จะเป็นการ Add สลักหลังเพิ่มไปเรื่อยๆต่อจากกรมธรรม์เดิม
                และเก็บเงินส่วนต่างทุกสิ้นเดือนกรมธรรม์ไม่มีการยกเลิก
              </li>
            </ol>
            <div style="display:flex;justify-content: center;" class="ma-3">
              <v-btn
                class="text-none"
                color="medium-emphasis"
                min-width="92"
                variant="outlined"
                elevation="0"
                rounded
                @click="updatePrice('False')"
              >
                ไม่ยอมรับ
              </v-btn>
              &emsp;
              <v-btn
                class="text-none font-weight-bold"
                :color="DarkModeButton"
                min-width="92"
                variant="outlined"
                rounded
                dark
                @click="updatePrice('True')"
              >
                ยอมรับ
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: [
    'toggleParent',
    'drawerParent',
    'languageSelectParent',
    'dataMenuParent',
    'priceMenuParent',
    'updatePriceMenuParent',
    'DarkModeButtonParent'
  ],
  data () {
    return {
      drawer: this.drawerParent,
      languageSelect: this.languageSelectParent,
      dataMenu: this.dataMenuParent,
      priceMenu: this.priceMenuParent,
      detailsNameSub: false,
      detailsData: '',
      DarkModeButton: this.DarkModeButtonParent
    }
  },
  async mounted () {},
  methods: {
    toggleJoyRide () {
      this.toggleParent()
    },
    updatePrice (items) {
      console.log('items >>>><<<<', items)
      this.$emit('updatePriceMenuParent', items)
      this.toggleParent()
    }
  },
  watch: {
    languageSelect () {
      this.languageSelect = this.languageSelectParent
    },
    drawerParent () {
      this.drawer = this.drawerParent
    },
    dataMenuParent () {
      this.dataMenu = this.dataMenuParent
    },
    DarkModeButtonParent () {
      this.DarkModeButton = this.DarkModeButtonParent
    }
  }
}
</script>
<style scoped>
.slide-enter,
.slide-leave-active {
  top: 100%;
}
.close-btn {
  border: none;
  font-weight: bold;
  font-size: 2em;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/sideMenuJoyRideInsure.vue